import { z } from 'zod';

export const createInternalTransferFormSchema = (maxAvailable?: number) => {
  return z.object({
    accNumFrom: z.string().nonempty({ message: '' }),
    accNumTo: z.string().nonempty({ message: '' }),
    assetFrom: z.string().nonempty({ message: '' }),
    assetTo: z.string().nonempty({ message: '' }),
    amount: z.string().refine(val => {
      if (!maxAvailable) return true;
      return (
        Number(val.replace(',', '.')) > 0 &&
        Number(val.replace(',', '.')) <= maxAvailable
      );
    }),
  });
};
